<template>
  <div>
    <vxe-grid
      resizable
      border
      round
      :loading="loading"
      :columns="tableColumn"
      :data="tabelData"
      size="mini"
      height="400"
    ></vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      page: {
        curPage: 1,
        pageSize: 100,
        pageTotal: 0
      },
      tabelData: [],
      tableColumn: [
        { type: 'seq', width: 50, align: 'center' },
        {
          field: 'appraisalBillName',
          title: '评价模板名称',
          minWidth: 300
        },
        {
          field: 'col-opt',
          title: '操作',
          width: 150,
          align: 'center',
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <b-button
                  class="mr-2"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.choiceData(row)}
                >
                  {this.$l('table_template_btn_choice') || '选择'}
                </b-button>
              ]
            }
          }
        }
      ]
    }
  },
  methods: {
    init() {
      this.queryData()
    },
    queryData() {
      let param = {}
      this.loading = true
      this.$api
        .scmAppraisalBillListApi({
          ...param,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tabelData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData(val) {
      this.$emit('success', val)
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 100,
        pageTotal: 0
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped></style>
